export const qrcodeKeys = {
    SHOW_QR_CODE: 'SHOW_QR_CODE',
}
